// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from './queries'
import { RawConfig } from '../store/slice/configSlice'
import { store } from '../store/store'

// API used for the Config ressource
export const apiEvent = createApi({
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        postEvent: builder.mutation<void, RawConfig>({
            query: (input) => {
                const storeConfig = store.getState().config.config
                let fullUrl = '/event'
                if (storeConfig && storeConfig['api_prefix']) {
                    fullUrl =
                        (!storeConfig['api_prefix'].match(/^\//) ? '/' : '') +
                        storeConfig['api_prefix'] +
                        '/event'
                }
                return {
                    url: fullUrl,
                    body: input,
                    method: 'POST',
                }
            },
        }),
    }),
    reducerPath: 'apiEvent',
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { usePostEventMutation } = apiEvent
